import React, { useEffect, useState } from "react";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import { useLocation, useNavigate } from "react-router-dom";
import { useGetTourPlanByMTPDayIdData } from "./hooks/useMTP";
import { useGetAgendaControlType } from "../Configuration/Agenda/UseAgenda";
import { FaEdit} from "react-icons/fa";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import MtpdayTourModal from "./components/MtpdayTourModal";

const MtpDayTourPlanColumns = (handleEditCategory:(row:any)=>void) => [
  {
    name: "Working",
    selector: (row: { working: string }) => row.working || "-",
    sortable: true,
    width:'120px'
  },
  {
    name: "Agenda",
    selector: (row: { Agenda: string }) => row.Agenda || "-",
    sortable: true,
    width:'120px'

  },
  {
    name: "Beat Town",
    selector: (row: { Beat_Town: string }) => row?.Beat_Town || "-",
    sortable: true,
    wrap: true,
    width:'150px'
  },
  {
    name: "Customer",
    selector: (row: { Customer: string }) => row?.Customer || "-", // (depend by backend)
    sortable: true,
    wrap: true,
    width:'120px'

  },
  {
    name: "Tags",
    selector: (row: { Tags: string }) => row?.Tags || "-", // (depend by backend)
    sortable: true,
    wrap: true,
  },
  {
    name: "VF",
    selector: (row: { Vf: string }) => row?.Vf || "-", // (depend by backend)
    sortable: true,
  },
  {
    name: "Focus Brand",
    selector: (row: { Focus_Brand: string }) => row?.Focus_Brand || "-", // (depend by backend)
    sortable: true,
    wrap: true,
    width:'160px' 
  },
  {
    name: "JW",
    selector: (row: { JW: string }) => row?.JW || "-", // (depend by backend)
    sortable: true,
  },
   {
          name: "Actions",
          cell: (row: any) => (
              <div className="d-flex align-items-center">
                  <button
                      onClick={() => handleEditCategory(row)}
                      className="btn btn-primary"
                      style={{ borderRadius: "20px", padding: "2px", width: "70px" }}
                  >
                      <FaEdit style={{ fill: "#fff" }} /> Edit
                  </button>
              </div>
          ),
      },

];

const MtpDayTourPlan = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { mtpDayRowData } = location?.state || {};
  const [status,setStatus]  =useState<string>('');

  const [OrgUnitId,setOrgUnitId] = useState<number|undefined>(undefined)
  const [working,setworking] = useState<string|undefined>(undefined)
  const [positionId,setpositionId] = useState<number|undefined>(undefined)
  
    

  const { data: agendaControlType } = useGetAgendaControlType({
    enabled: true,
  });
   
   
  const [paginationStates, setPaginationStates] = useState({
    page: 1,
    limit: 10,
    search:'',
    mtpDayId: mtpDayRowData?.MtpDayId,
  });

  const [model, setIsModal] = useState(false);
  const [rowData,setRowData] = useState<any>();

  const { isLoading, isSuccess, data } = useGetTourPlanByMTPDayIdData({
    enable: paginationStates?.mtpDayId ? true : false,
    params: {
      mtpDayId: paginationStates?.mtpDayId,
      page: paginationStates?.page,
      limit: paginationStates?.limit,
    },
  });
  
  useEffect(()=>{
    if(!isLoading && isSuccess && data){
        setOrgUnitId(data?.data?.MTPData?.OrgUnitId);
    }
    if(formatedData){

     setpositionId(formatedData[0]?.PositionId)
     setworking(formatedData[0]?.working);
    
    }
  },[data]);
  

  const handleEditCategory=(row:any)=>{
    // console.log("🚀 ~ handleEditCategory ~ row:", row)
    setIsModal(true);
    setStatus('Edit'); 
    setRowData(row);
  }

  const onCancel =()=>{
     setIsModal(false);
  }

  // console.log('mtpDayRowData==========>',mtpDayRowData.MtpDayDate);

  const formatedData = Array.isArray(data?.data?.TourplanData)
    ? data.data.TourplanData.map((item: any) => ({
        working: item.Agendacontroltype, // sub type
        Agenda: item.AgendaName,
        AgendaId:item.AgendaId,
        TpId:item.TpId, 
        Beat_Town: item.BeatTownName,
        BeatName:item.BeatName, 
        BeatId:item.BeatId || '-', // Patch
        Customer: item.OutletName,
        Tags: item.Tags,
        Vf: item.VisitFq,
        Focus_Brand: item.BrandFocus,
        JW: item.JWEmployee,
        MtpDayId:item.MtpDayId ||'-',

        OutletOrgDataId:item.OutletOrgDataId ||'-',  //customer

       PositionId:item.PositionId || '-' , //Territory
       TerritoryId:item.TerritoryId ||'-',
        OrgUnitId: data?.data?.MTPData?.OrgUnitId ||'-',
        OrgUnitName:data?.data?.MTPData?.OrgUnitName ||'-',
        TownName:item.TownName
      })): [];

  const handlePagination =(pageNo:number)=>{
    setPaginationStates((prev:any)=>({
          ...prev,
          page:pageNo
    }))
  }
   
  const handleonChangeRowsPerPage =(newPerPage:any, page:any)=>{
    setPaginationStates((prev:any)=>({
             ...prev,
             page:page,
             limit:newPerPage
    }))
  }

  const handleSearch =(val:any)=>{
     setPaginationStates((prev:any)=>({
          ...prev,
        search:val
     }))
  }


  return (
    <div className="p-4">
      <PageHeader title={mtpDayRowData?.MtpDayDate ||'-'} />
      <BasicDataTable
        dynamicHeightOnRowsPerPage={true}
        paginationTotalRows={data?.data.Pagination.TotalCount || 0}
        onChangePage={(pageNo: number) => { handlePagination(pageNo); }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page)
        }}
        handleSearch={(val: any) => { handleSearch(val) }}
        Title="Day tour plan view"
        columns={MtpDayTourPlanColumns(handleEditCategory)}
        data={(!isLoading && isSuccess && formatedData) || []}
        headerContent={
          <>
            <div style={{marginRight:'10px'}}> 
              <button
                onClick={() => {
                  setIsModal(true)
                  setStatus('add');
                }}
                style={{
                  border:'none',
                  outline: 'none',
                  display: "flex",
                  borderRadius: "20px",
                  width: "110px",
                  height: "40px",
                  justifyContent: "center",
                  textAlign: "center",
                  alignItems: "center",
                  backgroundColor:'#2E8DD3',
                  color:'#fff'
                }}
              >
             + Add Tour Plan
              </button>
            </div>
          </>
        }
      />
    
    <RouteModal
     isOpen={model}
     toggle={()=>setIsModal(!model)}
     title={status === "add"?"Add Tour Plan":"Edit Tour Plan"}
     size="md"
     content={
        <>
         <MtpdayTourModal 
        OrgUnitId={OrgUnitId}
        working={working}  
        status={status} 
        onCancel={onCancel} 
        rowData={rowData}
        positionId={positionId}
        /> 
        </>
     }
    />

    </div>
  );
};

export default MtpDayTourPlan;
